export const getIsVerifiedSeller = (sellerInformation: any, verticals: string[]): boolean => {
  return Boolean(sellerInformation?.isVerified && !verticals.includes('automotive'));
};
